import { ReactNode } from "react";

type NavMenuItemProps = {
	icon: ReactNode;
	label: string;
	isActive: boolean;
	onClick: () => void;
};

export default function NavMenuItem({ icon, label, isActive, onClick }: NavMenuItemProps) {
	return (
		<div
			className={`flex items-center w-full rounded-lg ${
				isActive ? "bg-grey-200 cursor-default" : "hover:bg-grey-100 cursor-pointer"
			}`}
			onClick={onClick}
		>
			<div className="m-3">{icon}</div>
			<p className="text-black text-base font-semibold w-full py-sm">{label}</p>
		</div>
	);
}
